import { render, staticRenderFns } from "./SingleWheelOfFortune.vue?vue&type=template&id=f1d8fe82&scoped=true&"
import script from "./SingleWheelOfFortune.vue?vue&type=script&lang=js&"
export * from "./SingleWheelOfFortune.vue?vue&type=script&lang=js&"
import style0 from "./SingleWheelOfFortune.vue?vue&type=style&index=0&id=f1d8fe82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d8fe82",
  null
  
)

export default component.exports